import { api, unwrap, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type {
  PayoutDestinationCategory,
  SelcomReferenceType,
  SelcomCatalogueEntry,
} from "../types/domain";

export interface CreateCatalogueEntryBody {
  name: string;
  shortcode: string;
  category: PayoutDestinationCategory;
  referenceType: SelcomReferenceType;
  lookupEnabled?: boolean;
  isActive?: boolean;
}

// shortcode is deliberately absent — immutable once created, see domain.ts.
export type UpdateCatalogueEntryBody = Partial<
  Omit<CreateCatalogueEntryBody, "shortcode">
>;

export const payoutCatalogueApi = {
  async list(
    params: ListParams & {
      category?: PayoutDestinationCategory;
      isActive?: boolean;
    },
  ): Promise<PaginatedResult<SelcomCatalogueEntry>> {
    const res = await api.get<ApiEnvelope<unknown>>("/admin/payout/catalogue", {
      params: cleanParams(params),
    });
    return toPaginated<SelcomCatalogueEntry>(res);
  },

  async create(body: CreateCatalogueEntryBody): Promise<SelcomCatalogueEntry> {
    const res = await api.post<ApiEnvelope<SelcomCatalogueEntry>>(
      "/admin/payout/catalogue",
      body,
    );
    return unwrap(res);
  },

  async update(
    id: string,
    body: UpdateCatalogueEntryBody,
  ): Promise<SelcomCatalogueEntry> {
    const res = await api.patch<ApiEnvelope<SelcomCatalogueEntry>>(
      `/admin/payout/catalogue/${id}`,
      body,
    );
    return unwrap(res);
  },

  /** Soft delete — sets isActive false server-side, never hard-deletes. */
  async remove(id: string): Promise<void> {
    await api.delete(`/admin/payout/catalogue/${id}`);
  },
};
